export default __webpack_public_path__ + "alberta-add.f0d08cbe5a581134beee.svg";